import lodash from "lodash";
import {
  ContactConfig,
  ContactFieldsConfig,
  ContactPreferencesConfig,
} from "../../../../../types/ContactConfig";

export const contactConfigTemplate: ContactConfig = {
  role: "Requester",
  canAssignToAnother: false,
  fieldsConfig: {
    optionalFirstName: false,
    optionalLastName: false,
    optionalEmail: false,
    optionalMobile: false,
    optionalAlternatePhone: false,
    optionalBusinessName: false,

    showEmail: true,
    showPhone: true,
    showBusinessName: true,
    showBusinessAddress: false,

    disabledFirstName: false,
    disabledLastName: false,
    disabledEmail: false,
    disabledMobile: false,
    disabledAlternatePhone: false,
    disabledBusinessName: false,
    disableBusinessAddress: false,
  },
  preferencesConfig: [
    {
      contactPreferenceType: "workContactPreferences",
      title: "Work update:",
      emailLabel: "Email",
      smsLabel: "SMS",
      emailDisabled: false,
      smsDisabled: false,
    },
  ],
};

export class ContactConfigBuilder {
  private config: ContactConfig;

  constructor() {
    this.config = lodash.cloneDeep(contactConfigTemplate);
  }

  withContactConfig(contactConfig: Partial<ContactConfig>): this {
    this.config = { ...this.config, ...contactConfig };
    return this;
  }

  withFieldsConfig(fieldsConfig: Partial<ContactFieldsConfig>): this {
    this.config.fieldsConfig = {
      ...this.config.fieldsConfig,
      ...fieldsConfig,
    };
    return this;
  }

  withPreferencesConfig(preferences: ContactPreferencesConfig[]): this {
    this.config.preferencesConfig = preferences;
    return this;
  }

  build(): ContactConfig {
    return this.config;
  }
}

const contactPreferencesConfigTemplate: ContactPreferencesConfig = {
  contactPreferenceType: "workContactPreferences",
  title: "Work update:",
  emailLabel: "Email",
  smsLabel: "SMS",
  emailDisabled: false,
  smsDisabled: false,
};

export class ContactPreferencesConfigBuilder {
  private config: ContactPreferencesConfig;

  constructor() {
    this.config = lodash.cloneDeep(contactPreferencesConfigTemplate);
  }

  withConfig(fieldsConfig: Partial<ContactPreferencesConfig>): this {
    this.config = {
      ...this.config,
      ...fieldsConfig,
    };
    return this;
  }

  build(): ContactPreferencesConfig {
    return this.config;
  }
}
